<template>
    <div class="container">
      <!-- 判断 records 是否为空 -->
      <div v-if="records.length === 0" class="no-data">
        <span>无报餐记录</span>
      </div>
  
      <!-- 遍历 records 数据，渲染每个报餐项 -->
      <div
        v-for="(record, index) in records"
        :key="index"
        class="appointment-item"
        @click="record.isHexiao === 0 && handleCancelOrder(record.id)"
      >
        <div class="appointment-header">
          <span class="name">{{ record.name }}</span>
          <span :class="{'status': true, 'canceled': record.isHexiao === 0}">
            {{ record.isHexiao === 1 ? '已核销' : '未核销' }}
          </span>
        </div>
        <div class="divider"></div>
        <div class="appointment-time">
          <span>报餐类型: {{ record.leixing }}</span>
          <span>金额: {{ record.money }}元</span>
          <span>优惠: {{ record.youhui }}元</span>
          <span>下单时间: {{ record.xiadanTime }}</span>
          <span>就餐时间: {{ record.jiucanTime }}</span>
        </div>
      </div>
    </div>
  </template>
  
  <script>

  
  export default {
    name: "RecordList",
    data() {
      return {
        records: [], // 初始为空，通过 API 获取数据
      };
    },
    created() {
      this.fetchRecords(); // 在组件创建时调用 API 获取数据
    },
    methods: {
      async fetchRecords() {
        try {
          const response = await this.$axios.get("/api/show_dingdan");
          const data = response.data;
          if (data.code === 0) {
            this.records = data.data;
          } else {
            console.error('Failed to fetch records:', data.message);
            this.records = []; // 如果获取失败，清空记录
          }
        } catch (error) {
          console.error("Error fetching records:", error);
          this.$message.error("加载报餐记录失败，请稍后再试");
        }
      },
      handleCancelOrder(id) {
        const confirmCancel = confirm("确定要取消订单吗？");
        if (confirmCancel) {
          this.cancelOrder(id);
        }
      },
      async cancelOrder(id) {
        try {
          const response = await this.$axios.post("/api/quxiao_dingdan", { id });
          const data = response.data;
          if (data.code === 0) {
            this.$message.success("订单已取消");
            this.fetchRecords(); // 重新加载数据
          } else {
            console.error('Failed to cancel order:', data.message);
            this.$message.error(data.message);
          }
        } catch (error) {
          console.error("Error canceling order:", error);
          this.$message.error(error);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .container {
    padding: 16px;
    background-color: #ffffff; /* 页面背景为白色 */
    height: 100%;
  }
  
  .no-data {
    text-align: center;
    color: #999;
    font-size: 16px;
  }
  
  .appointment-item {
    background-color: #ffffff; /* 框背景为白色 */
    border: 1px solid #ddd; /* 框边框为灰色 */
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
    cursor: pointer; /* 可点击 */
  }
  
  .appointment-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  
  .appointment-header .name {
    font-weight: bold;
    font-size: 18px;
  }
  
  .status {
    color: #5cb85c;
  }
  
  .canceled {
    color: red;
  }
  
  .divider {
    border-bottom: 1px solid #ddd;
    margin-bottom: 12px;
  }
  
  .appointment-time span {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
  }
  </style>